import React from 'react';
import { Message, Image, Icon } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import logo from "../../images/logo/logo-white.png";
import LoadingComponent from "../common/LoadingComponent";
import ModalHeader from './../drive/ModalHeader';
import { singleLinePassword } from '../common/RegexValidation';
import linkExpriedImage from '../../images/grafix-banner/gfx-link-expired.svg';

const errorLabel = <div className="customErrorLabel" />;

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.goToLogin = this.goToLogin.bind(this);
    }

    goToLogin(e) {
        e.preventDefault();
        this.props.history.push('/login');
    }

    state = {
        password: '',
        showPassword: false,
        confirmPassword: '',
        showConfirmPassword: false
    }
    togglePasswordVisibility = () => {
        this.setState({ showPassword: !this.state.showPassword, password: this.state.password })
    }

    toggleConfirmPasswordVisibility = () => {
        this.setState({ showConfirmPassword: !this.state.showConfirmPassword, confirmPassword: this.state.confirmPassword })
    }

    componentDidMount() {
        let userid = this.props.match.params.userid;
        let otp = this.props.match.params.otp;
        let formData = {};
        formData.userid = userid;
        formData.otp = otp;
        dispatch.reset.checkOtpAsync(formData);
    }

    onSubmit(formData) {
        let userid = this.props.match.params.userid;
        let otp = this.props.match.params.otp;
        formData.userid = userid;
        formData.otp = otp;
        formData.check = 'resetpassword'
        dispatch.reset.resetpasswordAsync(formData);
    }

    render() {
        const { resetPwd, resetError, checkOtp, checkOtpError, version } = this.props;
        const { password, showPassword, confirmPassword, showConfirmPassword } = this.state;
        return (
            <div className="login-main" style={{ height: '100%' }}>
                <LoadingComponent active={resetPwd} message="Updating Password..." />
                <LoadingComponent active={checkOtp} message="Loading..." />
                <div className="left-section">
                    <div className='centered' style={{ justifyContent: "flex-start", paddingTop: "80px" }}>
                        <h2 className="f_24 ff_b float-left" style={{ color: "#707070", fontWeight: "normal", display: "flex", alignItems: "center", gap: "8px", paddingLeft: "10px" }}>
                            <a href="#" onClick={this.goToLogin} id="backLink" style={{
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: "28px", height: "28px",
                                border: "1px solid #d4d4d4", borderRadius: "6px",
                                color: "#707070", textDecoration: "none"
                            }}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="15 18 9 12 15 6"></polyline>
                                </svg>
                            </a>
                            Reset your Password
                        </h2>

                        {checkOtpError ?
                            <div style={{ paddingLeft: "10px", textAlign: "center" }}>
                                <Image style={{ height: "160px" }} src={linkExpriedImage} centered={true} />
                                <p className="f_18 clr-orange">
                                    Reset password link is expired!
                                </p>
                            </div>
                            :
                            <Form noValidate
                                className="loginform"
                                error
                                ref={ref => this.form = ref}
                                onValidSubmit={this.onSubmit}
                                id="resetpasswordform"
                            >
                                {resetError ?
                                    <Message
                                        error
                                        content={resetError}
                                    /> : ''}
                                <div style={{ paddingLeft: "10px", position: "relative", marginBottom: "18px" }}>
                                    <Form.Input
                                        name="password"
                                        label="New Password"
                                        placeholder="Enter Password"
                                        type={showPassword ? 'text' : 'password'}
                                        icon="key"
                                        iconPosition="left"
                                        required
                                        errorLabel={errorLabel}
                                        validations={{
                                            minLength: 8, matchRegexp: singleLinePassword, sameAsEmail: (values) => {
                                                return this.props.userEmail && values.password && values.password.toLowerCase() !== this.props.userEmail.toLowerCase()
                                            }
                                        }}
                                        validationErrors={{
                                            minLength: 'Minimum of 8 characters',
                                            matchRegexp: 'Space not allowed',
                                            equalsField: 'Should be same as Password',
                                            isDefaultRequiredValue: 'New Password is required',
                                            sameAsEmail: 'Password cannot be the same as your email address',
                                        }}
                                        id="password"
                                        instantValidation
                                        value={password}
                                        onChange={(e) => this.setState({ password: e.target.value })}
                                        action={<Icon
                                            name={showPassword ? 'eye' : 'eye slash'}
                                            link
                                            onClick={this.togglePasswordVisibility}
                                            style={{ left: "auto", right: "1px" }}
                                        />}
                                        style={{ marginTop: "1px" }}
                                    />
                                </div>
                                <div style={{ paddingLeft: "10px", position: "relative", marginBottom: "18px" }}>
                                    <Form.Input
                                        name="confirmPassword"
                                        label="Confirm Password"
                                        placeholder="Enter Password"
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        icon="key"
                                        iconPosition="left"
                                        required
                                        errorLabel={errorLabel}
                                        validations="equalsField:password"
                                        validationErrors={{
                                            equalsField: 'Should be same as Password',
                                            isDefaultRequiredValue: 'Confirm Password is required',
                                        }}
                                        id="confirmPassword"
                                        instantValidation
                                        value={confirmPassword}
                                        onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                                        action={<Icon
                                            name={showConfirmPassword ? 'eye' : 'eye slash'}
                                            link
                                            onClick={this.toggleConfirmPasswordVisibility}
                                            style={{ left: "auto", right: "1px" }}
                                        />}
                                        style={{ marginTop: "1px" }}
                                    />
                                </div>

                                <div style={{ paddingLeft: "10px" }}>
                                    <Button className="button-submit ff_sb" type="submit" id="submit" style={{ width: "100%" }}>Submit</Button>
                                </div>
                            </Form>
                        }
                    </div>
                    <div className="f_8 mar_0 bottom" style={{ height: "46px", padding: "5px 10px", width: "100%" }}>
                        <div className="float-left">
                            Copyright &#169; {new Date().getFullYear()} Aspenify <br />Version {version ? version : ""}
                        </div>
                        <div className="float-right text-right">
                            Visit us at <br />
                            <a href="https://www.aspenify.com" rel="noopener noreferrer" style={{ color: "#6b6b6b" }} target="_blank" > www.aspenify.com </a>
                        </div>
                    </div>
                </div>

                <div className="right-section display-flex " style={{ flexDirection: 'column' }}>
                    <div className='login-right-div '>
                        <div>
                            <ModalHeader
                                header={<a href="https://aspenify.com" target="_blank" rel="noopener noreferrer"><img src={`${logo}`} alt="Logo" style={{ width: '40vw', height: 'auto', cursor: 'pointer' }} /></a>}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        resetPwd: state.loading.effects.reset.resetpasswordAsync,
        resetError: state.reset.resetPwdError,
        checkOtp: state.loading.effects.reset.checkOtpAsync,
        checkOtpError: state.reset.checkOtpError,
        userEmail: state.reset.userEmail,
        version: state.login.version,
    };
}

const connectedLoginPage = connect(mapStateToProps)(ResetPassword);

export default connectedLoginPage;
